export const FileManagerTypes: string[] = [
  "Reports",
  "Salaries",
  "Expenses",
  "Other",
];
